import KalkulatorBMI from "../../../../src/embed/kalkulatorBMI";
import KalkulatorBeratIdeal from "../../../../src/embed/KalkulatorBeratIdeal";
import * as React from 'react';
export default {
  KalkulatorBMI,
  KalkulatorBeratIdeal,
  React
};